import React, { useState, forwardRef } from 'react';
import { UserMenu, Logout, useUserMenu } from 'react-admin';
import { Badge, MenuItem } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { ChangePasswordDialog } from '../dialogs/ChangePasswordDialog.tsx';
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useSupportNotification } from '../../context/SupportNotificationContext.tsx';

const ChangePasswordMenuItem = forwardRef(({ onOpenDialog, ...props }, ref) => {
    const { onClose } = useUserMenu();

    const handleClick = () => {
        onClose();

        setTimeout(() => {
            onOpenDialog();
        }, 200);
    };

    return (
        <MenuItem ref={ref} onClick={handleClick} {...props}>
            Change password
        </MenuItem>
    );
});

const ProfileMenu = (props) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const isVendor = localStorage.getItem("ra_role") === "VENDOR";
    const { hasUnread } = useSupportNotification();
    return (
        <>
            <UserMenu
                {...props}
                icon={
                    <Badge
                        color="error"
                        variant="dot"
                        invisible={!hasUnread || isVendor}
                    >
                        <AccountCircleIcon />
                    </Badge>
                }
            >
                {!isVendor && <MenuItem onClick={() => navigate("/support")} {...props}>
                    {t('resources.support')}
                </MenuItem> }
                <ChangePasswordMenuItem onOpenDialog={() => setDialogOpen(true)} />
                <Logout />
            </UserMenu>
            <ChangePasswordDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
            />
        </>
    );
};

export default ProfileMenu;